import {AsYouTypeFormatter} from 'google-libphonenumber';

export const formatPhoneNumberField = v => {
  const phoneNumberFormatter = new AsYouTypeFormatter('US');
  let phoneNumber = '';
  for (const n of v || []) {
    phoneNumber = phoneNumberFormatter.inputDigit(n);
  }
  return phoneNumber;
};
